import useTooltip from "../../../hooks/useTooltip.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMailbox } from "@fortawesome/pro-solid-svg-icons";
import formatDate from "../../../helpers/formatDate.ts";

export default function NewsletterIndicator({
  plannedForNewsletterAt,
  sentInNewsLetterAt,
}: {
  plannedForNewsletterAt?: string | null;
  sentInNewsLetterAt?: string | null;
}) {
  const tooltipRef = useTooltip<HTMLDivElement>();

  return (
    <div
      ref={tooltipRef}
      className="btn btn-sm text-muted"
      title={
        plannedForNewsletterAt
          ? I18n.t("js.activitystreams.newsletter.tooltip")
          : sentInNewsLetterAt
            ? I18n.t(
                "js.activitystreams.newsletter.was_in_newsletter_tooltip",
                {
                  in_newsletter_at: formatDate(
                    new Date(sentInNewsLetterAt),
                    "PPPP, HH:mm",
                  ),
                },
              )
            : ""
      }
    >
      <FontAwesomeIcon icon={faMailbox} />
    </div>
  );
}
